import NewModal from "../../shared/Modals/NewModal";
import { useTranslation } from "react-i18next";
import TelepromterWrapper from "./TeleprompterWrapper";

const TelepromterModal = ({ show, setShow, post }) => {
  const { t } = useTranslation();


  return (
    <NewModal show={show} setShow={setShow} fullscreen={true}>
        <TelepromterWrapper text={post ? post.text : ""} />
    </NewModal>
  );
};

export default TelepromterModal;
